export const COLORS = [
  '#94d6d8',
  '#fcd22e',
  '#212957',
  '#418172',
  '#ef4939'
]

